import { BackendBaseModel, coerceNullToUndefined } from '@/utils';
import { z } from 'zod';

import { ListBaseModel } from '@/api/models';
import { WorkflowModel, WorkflowStageFormStageFieldSchema } from './workflow';

const WorkflowTemplateDataModel = z.object({
  title: WorkflowModel.shape.title.nullish().transform(coerceNullToUndefined),
  tagIds: z.string().uuid().array().nullish().transform(coerceNullToUndefined),
  content: WorkflowModel.shape.content
    .nullish()
    .transform(coerceNullToUndefined),
  workflowType: WorkflowModel.shape.workflowType
    .nullish()
    .transform(coerceNullToUndefined),
  stages: WorkflowStageFormStageFieldSchema.extend({
    stageType: WorkflowStageFormStageFieldSchema.shape.stageType
      .nullish()
      .transform(coerceNullToUndefined),
  })
    .array()
    .nullish()
    .transform(coerceNullToUndefined),
});

export const WorkflowTemplateModel = BackendBaseModel.extend({
  name: z.string().min(1),
  data: WorkflowTemplateDataModel.nullable(),
});

export const WorkflowTemplatesModel = WorkflowTemplateModel.array();

export const WorkflowTemplatesWithPaginationModel = ListBaseModel.extend({
  results: WorkflowTemplateModel.extend({
    organizationIds: z.string().uuid().array(),
    organizations: z
      .object({
        organizationId: z.string().uuid(),
        organizationName: z.string(),
      })
      .array(),
  }).array(),
});

export const WorkflowTemplateFormSchema = WorkflowTemplateDataModel.extend({
  name: WorkflowTemplateModel.shape.name,
  organizationIds: z.string().uuid().array().array().min(1),
});

export const UpdateWorkflowTemplateParamsSchema =
  WorkflowTemplateFormSchema.extend({
    id: z.string().uuid(),
  });

export const WorkflowTemplateSearchFormSchema = z.object({
  q: z.string().nullish(),
  nestedOrganizationIds: z.string().uuid().array().array(),
});
